module.exports = __webpack_public_path__ + "img/企业文化.3a3ed5b2.jpg";